import Joi from 'joi';

export const configSchema = Joi.object({
  adventCalendarEnabled: Joi.boolean(),
  adventCalendarUrl: Joi.string().uri(),
  changeRentPaymentMethodEnabled: Joi.boolean(),
  digitalFormsEnabled: Joi.boolean(),
  heatingAndEnergyEnabled: Joi.boolean(),
  lettersEnabled: Joi.boolean(),
  lettersEnabledForCondo: Joi.boolean(),
  welcomeLetterEnabled: Joi.boolean(),
  loyaltyEnabled: Joi.boolean(),
  ocCalculationsEnabled: Joi.boolean(),
  ocInspectionEnabled: Joi.boolean(),
  operationalCostPrepaymentEnabled: Joi.boolean(),
  pmOcInspectionEnabled: Joi.boolean(),
  rentAccountEnabled: Joi.boolean(),
  rentCertificatePaidEnabled: Joi.boolean(),
  rentCertificatePostalEnabled: Joi.boolean(),
  rentContractDocumentsEnabled: Joi.boolean(),
  srAmendmentImagesEnabled: Joi.boolean(),
  verificationEnabled: Joi.boolean(),
  verificationMethodSms: Joi.boolean(),
  verificationMethodEmail: Joi.boolean(),
  contactDetailsEnabled: Joi.boolean(),
  verificationMethodEmailEnabled: Joi.boolean(),
  verificationMethodEmailJwt: Joi.string(),
  verificationMethodEmailLifetime: Joi.number().integer(),
  eventsEnabledWeb: Joi.boolean(),
  topDealsEnabled: Joi.boolean(),
  faqEnabled: Joi.boolean(),
  rentContractOverviewEnabled: Joi.boolean(),
  condoContractOverviewEnabled: Joi.boolean(),
  condoContractDocumentsEnabled: Joi.boolean(),
  financialPlansAndCondoStatementsEnabled: Joi.boolean(),
  condoReceiptInspectionFeaturesEnabled: Joi.boolean(),
  pageCondoAccountBalanceVisibleTo: Joi.string(),
  pageChangeRentPaymentMethodVisibleTo: Joi.string()
}).unknown(true);
